<div class="container py-4">
  <h2 class="m-1 title">Write News here..</h2>
 
  <div class="opening-filter p-4 mb-2">
    <form [formGroup]="Newsform" >
      <div class="mb-3">
        <label for="Title-name" class="col-form-label">Title</label>
        <input type="text" class="form-control" formControlName="title" id="Title-name">
      </div>
      <div class="mb-3">
        <label for="message-text" class="col-form-label">Body</label>
        <textarea class="form-control" id="message-text" formControlName="body"></textarea>
      </div>
      <div class="mb-3">
        <label for="img" class="col-form-label">Select image</label>
        <input type="file" id="img" name="img" (change)="onFileSelected($event)" formControlName="image" class="form-control" accept="image/*">
      </div>
      <div class="editor editor-toolbar">
        <ngx-editor-menu
          [editor]="editor"
          [toolbar]="toolbar"
          class="toolbar-container"
        >
        </ngx-editor-menu>
      </div>
      <ngx-editor [editor]="editor" formControlName="editorContent">
      </ngx-editor>
      <div class="my-2">
        <img [src]="selectedImage" class="img-fluid" alt="">
      </div>
      <button type="button" class="btn news-btn me-2" (click)="blogFormReset()">Reset</button>
      <button type="submit" (click)="newsFormData(Newsform.value)" [disabled]="!Newsform.valid" class="btn news-btn">Add News</button>
    </form>
  </div>


</div>



